// Additional interests API (ADDITIONAL-INTERESTS-SPEC Part A/C).
// Backed by routes/interests.routes.js at /api/interests.

import { api } from '@/lib/api.js';
import { fileDealDocuments } from '@/services/deals.service.js';

export function listDealInterests(dealId) {
  return api.get(`/api/interests/deals/${encodeURIComponent(dealId)}`);
}

export function listAccountInterests(accountId, { includeEnded = false } = {}) {
  return api.get(`/api/interests/accounts/${encodeURIComponent(accountId)}${includeEnded ? '?include_ended=true' : ''}`);
}

export function createInterest(body) {
  return api.post('/api/interests', body);
}

// A refused email (400 BAD_EMAIL, not an address) is expected: the caller shows the server's sentence where it was typed.
export const UPDATE_INTEREST_EXPECTED = [{ status: 400, code: 'BAD_EMAIL' }];
export function updateInterest(id, body, { expected } = {}) {
  return api.patch(`/api/interests/${encodeURIComponent(id)}`, body, expected ? { expected } : undefined);
}

export function endInterest(id, reason) {
  return api.post(`/api/interests/${encodeURIComponent(id)}/end`, { reason });
}

// Prompt 171 §12: record that the broker looked at a carried interest this term.
export function confirmInterestForTerm(id, dealId) {
  return api.post(`/api/interests/${encodeURIComponent(id)}/confirm-term`, { crm_deal_id: dealId });
}

// cc: "Add others (CC)" (round 2, Q21), as typed; the server validates them (400 BAD_CC) and copies them on the holder's mail.
export function sendInterestCert(id, dealId, cc = []) {
  return api.post(`/api/interests/${encodeURIComponent(id)}/send-cert`, { deal_id: dealId, cc });
}

// The carrier's certificate for this interest, filed through the deal's document door (paperwork-1 L1b-B1: kind certificate,
// naming this interest, fileDocument on the deal's policy). Answers the door's answer for the file: { ok, document } (the
// stored row with its derived name), or { ask: candidates } when the server asks whether it replaces a filed certificate
// for the same holder (asked, never inferred; call again with replaces = a candidate id or 'none'). A refusal throws.
export async function uploadInterestCert(id, dealId, file, { replaces } = {}) {
  const body = await fileDealDocuments(dealId, [{ file, kind: 'certificate', interest_id: id, replaces_document_id: replaces }]);
  const r = body.results[0] || {};
  if (r.code === 'REPLACES_UNANSWERED') return { ask: r.candidates || [] };
  if (!r.ok) throw new Error(r.error || `Not filed (${r.status || 'no answer'})`);
  return r;
}
